import { MenuProvider } from "./MenuContext";
import InnerApp from "./InnerApp.jsx";
import { Provider } from "react-redux";
import store from "./store/store";
import { setupAxiosInterceptors } from "./api/setupAxiosInterceptors";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.css";

setupAxiosInterceptors();

function App() {
  return (
    <>
      <Provider store={store}>
        <MenuProvider>
          <InnerApp />
        </MenuProvider>
      </Provider>
    </>
  );
}

export default App;
